import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Card as CardTable, Container as ContainerBody, Row, Col, Dropdown } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';
import Modal from "react-bootstrap/Modal";
import Radio from '@material-ui/core/Radio';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import {
  Container,
  CardOrder,
  MainContainer
} from '~/components/layout/Logistic/styles';
import {
  Align,
  AlignDropdownBranch,
  ButtonDivision,
  CardHeader,
  CardHeaderTotal,
  CardInput,
  CardInputItem,
  CenterHeaderQuantity,
  CenterItemQuantityDesktop,
  CenterItemQuantityMobile,
  CloseIconStyled as IconStyled,
  ColAppliedHeaderQuantity,
  ContainerCard,
  InputApply,
  LeftItemQuantity,
  LeftItemQuantityDesktop,
  LeftItemQuantityMobile,
  LeftItemQuantityTotalDesktop,
  LeftItemQuantityTotalMobile,
  LeftItemReplacementDesk,
  LeftItemReplacementMobile,
  LeftItemSubdisizedDesk,
  LeftItemSubdisizedMobile,
  LoadingIcon,
  ModalContent,
  PrintIconStyled,
  Product,
  RightItemQuantity,
  RightItemQuantityTotal,
  Select,
  TextQuantity,
  TextQuantityHeader,
  Title,
  TitlePage as IconsTop,
} from './styles';

import '~/components/styles/Global.css';
import close from '~/assets/images/close.png';
import IconProduct from '~/components/layout/IconProduct';
import api from '~/services/api';
import Loading from '~/components/layout/Loading';
import OpenChatBot from '~/components/layout/Chatbot';
import Stepper from '~/components/layout/Logistic/StepperLine';
import back from '~/assets/images/back.svg';
import PrinterIcon from '~/assets/images/printer.svg';
import RedirectToInitial from '~/components/layout/Logistic/RedirectToInitial';
import RedirectToPortal from '~/components/layout/Logistic/RedirectToPortal';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import { InfoButton } from '~/components/layout/Buttons';


export default function Resume() {
  const dispatch = useDispatch();
  const history = useHistory();
  const componentRef = useRef();

  const roles = useSelector(state => state.rolesReducer.roles);
  const logisticReducer = useSelector(state => state.logisticReducer);
  const economicGroupReducer = useSelector(state => state.economicGroupReducer);

  const [loadingPage, setLoadingPage] = useState(true);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [loadingConfirmModal, setLoadingConfirmModal] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [ modalOpen, setModalOpen] = useState(false);
  const [emails, setEmails] = useState([]);
  const [expandEmail, setExpandEmail] = useState(false);
  const [emailIndex, setEmailIndex] = useState(0);
  const [email, setEmail] = useState(localStorage.getItem('email'));
  const [phone, setPhone] = useState('');
  const [modalRedirect, setModalRedirect] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);


  useEffect(() => {
    console.log("reducer logistic resume => ", logisticReducer)
    getListOfEmployeesActive();
  }, []);

  const isMobile = window.screen.width < 771;

  const mapperServiceType = {
    RETIRA: 'RETIRA',
    ENTREGA: 'ENTREGA'
  };


  const descriptions = {
    AV_CR_DCTO_CM_HUB_BA: isMobile ? 'Desc. comercial HUB'    : 'Desconto comercial HUB',
    AV_CR_DESC_AVULSO:    isMobile ? 'Desc. avulso'           : 'Desconto avulso',
    AV_CR_DES_ADTOPIXBA:  isMobile ? 'Desc. adiantamento PIX' : 'Desconto adiantamento PIX',
    AV_CR_DES_ADTOPIXUG:  isMobile ? 'Desc. adiantamento PIX' : 'Desconto adiantamento PIX',
    AV_CR_DSCTO_COM_HUB:  isMobile ? 'Desc. comercial HUB'    : 'Desconto comercial HUB',
    AV_CR_DST_LAPIDARBA:  isMobile ? 'Desc. Lapidar'          : 'Desconto Lapidar',
    AV_CR_DST_LAPIDARUG:  isMobile ? 'Desc. Lapidar'          : 'Desconto Lapidar'
  };


  function formatContactNumber(value) {
    const cleanNumber = value.replace(/\D/g, '');

    if (cleanNumber.length === 11) {
      return cleanNumber.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else if (cleanNumber.length === 10) {
      return cleanNumber.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else {
      return value;
    }
  }

  function getStoresId () {
    const storeIdList = [];
    if (storeIdList.length < 1) {
      let listStores = [];

      economicGroupReducer.stores.map(store => {
        listStores = [...listStores, store.storeId];
        return null;
      });

      let storesToString;

      if (listStores) {
        storesToString = listStores.toString()
      }

      return storesToString;
    } else {
      return storeIdList;
    }
  };

  async function getListOfEmployeesActive() {
    try {
        const listStores = getStoresId();
        const header = {
            'Content-Type': 'application/json',
            access_token: localStorage.getItem('access_token'),
        };

        const parameters = {
            method: 'POST',
            headers: header,
        };

        const res = await api.get(
            `residential/store/v1/users?store-id-access=${listStores}&_expand=CONTACT&_limit=1000&_offset=0&is-active=true`,
            parameters,
        );

        const emailsFromApi = extractEmails(res.data);
        const emailFromLocalStorage = localStorage.getItem('email');

        const emailsWithId = emailsFromApi.map((email, index) => ({
            id: (index + 1).toString(),
            email: typeof email === 'object' ? email.email : email,
        }));

        if (emailFromLocalStorage) {
            const nextId = emailsWithId.length + 1;
            const emailLocalStorageObject = typeof emailFromLocalStorage === 'object' ? emailFromLocalStorage : { email: emailFromLocalStorage };
            const emailLocalStorageValue = emailLocalStorageObject.email;

            if (!emailsWithId.some(item => item.email === emailLocalStorageValue)) {
                emailsWithId.push({
                    id: nextId.toString(),
                    email: emailLocalStorageValue,
                });
            }
        }

        const uniqueEmails = Array.from(new Set(emailsWithId.map(item => item.email)));

        const finalEmailList = uniqueEmails.map((email, index) => ({
            id: (index + 1).toString(),
            email: email,
        }));

        finalEmailList.sort((a, b) => parseInt(b.id) - parseInt(a.id));

        setEmails(finalEmailList);
    } catch (err) {
        console.log('err =>', err);
        console.error(err);
    }
  };

  function extractEmails(payload) {

    const emails = payload.reduce((acc, item, index) => {
      if (
        item.roles &&
        (item.roles.some(role => role.name === "STATUS_DO_PEDIDO") ||
        item.roles.some(role => role.name === "PEDIDO_DE_ABASTECIMENTO"))
      ) {
        acc.push({
          id: (index + 1).toString(),
          email: item.login,
        });
      }
      return acc;
    }, []);

    if (emails.length === 0) {
      const email = localStorage.getItem('userEmail');
      return [{ id: 0, email: email }]
    }

    return emails;
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  async function getOrderDetails() {

    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem("access_token")
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    try {
      const  { data }   = await api.get(`/sales/order/v2/orders-ga/${logisticReducer.orderDraft.response.orderId}`, parameters)

      setOrderDetails(data);

      dispatch({
         type: 'SET_ORDER_LOGISTIC',
         order: data
      });
      dispatch({
        type: 'SET_ORDER_PAYMENT',
        order: data
      });

      setLoadingPage(false);
      return data

    } catch (err) {
      console.log('err => ', err);
      toast.error('Não foi possível consultar o status do seu pedido. Por favor, tente novamente ou acione o SAP Local');
      setTimeout(() => {
        setLoadingPage(false);
        history.push('/portal')
      }, 3500);
    }
  }

  useEffect(()=>{
    getOrderDetails();
  },[])

  function formatCurrency(value) {
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function getTotalCoast() {
    const totalCost = orderDetails.products.reduce((total, product) => {
      return total + product.unitPrice * product.quantity;
    }, 0);
    return totalCost;
  }

  function getTotalSubsidizedApplied() {
    const totalSubsidizedApplied = orderDetails.products.reduce((total, product) => {
      return total + (product.sponsoredQuantity) * product.unitPrice;
    }, 0);
    return totalSubsidizedApplied;
  }

  function getTotalReplacementApplied() {
    const totalReplacementsApplied = orderDetails.products.reduce((total, product) => {
      return total + (product.voucherQuantity + product.shiftQuantity) * product.unitPrice;
    }, 0);
    return totalReplacementsApplied;
  }

  function getTotalDiscount() {

    if (orderDetails.creditNotesDiscount.length === 0) {
      const totalDiscount = (orderDetails.shippingTaxDiscount +  orderDetails.reweighingDiscountValue);
      return totalDiscount
    }

    const totalDiscount = orderDetails.creditNotesDiscount.reduce((total, product) => {
      return total + product.value ;
    }, 0);

    return totalDiscount - (orderDetails.shippingTaxDiscount +  orderDetails.reweighingDiscountValue);
  }

  function getTotal() {
    if(getTotalDiscount() > 0 ) {
      const total = (getTotalCoast() - getTotalReplacementApplied() - getTotalDiscount());
      return total;
    } else {
      const total = getTotalCoast() - (getTotalReplacementApplied() - getTotalDiscount());
      return total;
    }
  }

  const formatCreditNoteDescription = (productName) => {
    return descriptions[productName] || 'Descrição não encontrada';
  };

  function getPayloadOrderCompletion() {
    if (logisticReducer.deliveryType === mapperServiceType.RETIRA) {
      return {
        shippingCompanyId: logisticReducer?.business?.businessCharacteristicId ? logisticReducer.business.businessCharacteristicId : '',
        licensePlateId: logisticReducer?.business?.shippingFleet?.vehiclesLicensePlates[0]?.id ? logisticReducer.business.shippingFleet.vehiclesLicensePlates[0].id : '',
        contactEmail: modalOpen ? email : localStorage.getItem('email'),
        contactPhoneNumber: phone
      };
    }
    return {
      contactEmail: modalOpen ? email : localStorage.getItem('email'),
      contactPhoneNumber: phone
    };
  }

  async function orderCompletion() {

      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token'),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      const payload = getPayloadOrderCompletion();

      try {
        setLoadingConfirm(true);
        setLoadingConfirmModal(true);

        await api.post(
          `/sales/order/v2/orders-ga/${logisticReducer.orderDraft.response.orderId}/finish`,
          payload,
          parameters
        );

        handleNextStep();
      } catch (err) {
        console.log('err => ', err);

        setLoadingConfirm(false);
        setLoadingConfirmModal(false);
        const status = err.response?.status;
        const message = err.response?.data?.message;

        if (status === 422) {
            if (message.includes('List index out of bounds')){
              toast.error( 'Não foi possível prosseguir com o pedido. Erro de inconsistência no cadastro. Verifique as informações com a logística e tente novamente.');
            } else {
              toast.error(message || 'Erro de validação nos dados.');
            }
        } else if (status === 401) {
            toast.error('Sua sessão expirou. Faça login novamente.');
        } else {
            toast.error('Ocorreu um problema de conexão. Por favor, tente novamente em alguns instantes.');
        }
        setTimeout(() => {
          setLoadingPage(false);
          history.push('/portal')
        }, 3500);

      }


  };

  function handleNext() {
    if (verifyInCash(orderDetails.products[0].paymentCondition)) {
      handleModal();
    } else {
      orderCompletion();
    }
  }

  async function handleNextStep() {
    setLoadingConfirm(true);

    let orderDetails;
    let maxAttempts = 6;

    while (maxAttempts > 0) {
      orderDetails = await getOrderDetails();

      if (orderDetails.orderStatus !== 'EM VALIDAÇÃO') {
        break;
      }

      await new Promise(resolve => setTimeout(resolve, 4000));
      maxAttempts--;
    }

    if (maxAttempts === 0) {
      handleMaxAttemptsExceeded();
    } else {
      handleOrderDetails(orderDetails);
    }

    setLoadingConfirm(false);
  }

  function handleMaxAttemptsExceeded() {
    toast.error(`O pedido ${orderDetails.number} foi criado e está em processamento. Acompanhe o andamento em "Status do Pedido."`);
    setLoadingConfirm(false);
    history.push('/lista-de-pedidos');
  }

  function handleOrderDetails(orderDetails) {
    if (verifyInCash(orderDetails && orderDetails.products[0].paymentCondition)) {
      history.push('/pagamento-via-pix');
    } else {
      if (orderDetails && orderDetails.creditCheck.customerSituation === 'ADIMPLENTE') {
        history.push('/pedido-recebido');
      } else {
        history.push('/necessario-quitar-debito');
      }
    }
  }

  function checkPaymentCondition(products, type) {
    const allAre = products.every((product) =>
      product.paymentCondition.includes(type)
    );

    return allAre;
  }

  function verifyInCash(text) {
    if (!text) {
      return false;
    }
    return text.includes("A Vista");
  }

  function handleModal() {
    setLoadingConfirm(!loadingConfirm);
    setModalOpen(!modalOpen);
  }

  useEffect(() => {
    dispatch({
      type: 'SELECT_EMAIL_INDEX',
      selectedEmailIndex: emailIndex
    });
  }, [emailIndex]);


  const CustomSelectEmail = React.forwardRef(({ children, onClick }, ref) => {
    return (
      <Select
        ref={ref}
        onClick={event => {
          event.preventDefault();
          onClick(event);
          expandEmail ? setExpandEmail(false) : setExpandEmail(true);
        }}
        onBlur={event => {
          onClick(event);
          expandEmail ? setExpandEmail(false) : setExpandEmail(true);
        }}
      >
        <span style={{ fontSize: '0.9rem'}}>{children}</span>
        {expandEmail ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </Select>
    );
  });

  function handleBack() {
    if (logisticReducer.financialDiscount.applied) {
      history.push('/composicao-financeira-descontos');
    } else if (logisticReducer.replacement.applied) {
      history.push('/composicao-financeira-reposicoes');
    } else if (logisticReducer.subsidized.applied) {
      history.push('/vasilhames-subsidiados');
    } else if (logisticReducer.previousPage === '/criar-pedido') {
      setModalRedirect(true);
    } else {
      history.push(logisticReducer.previousPage);
    }
  }


  return (
    <Container>
      {verifyRoles(roles, 'PEDIDO_DE_ABASTECIMENTO') ? (
        <>
          <IconsTop>
            <IconStyled
              src={back}
              alt="Ícone de voltar"
              onClick={() => handleBack()}
            />
            <IconStyled
              src={close}
              alt="Ícone de fechar"
              onClick={() => setModalCancel(true)}
            />
          </IconsTop>
          <RedirectToInitial
            modalRedirect={modalRedirect}
            setModalRedirect={setModalRedirect}
          />
          <RedirectToPortal
            modalRedirect={modalCancel}
            setModalRedirect={setModalCancel}
          />
          {loadingPage || !orderDetails ? (
            <Loading loadingColor={'white'} />
          ) : (
            <>
              <CardOrder ref={componentRef}>
                <div>
                  <MainContainer>
                    <Title>
                      <span>Resumo do Pedido</span>
                      <PrintIconStyled
                        src={PrinterIcon}
                        alt="Ícone de voltar"
                        onClick={handlePrint}
                      />
                    </Title>
                    <Stepper activeStep={6} steps={7} />
                    <CardInputItem>
                      <Row>
                        <Col className="p-0">
                          <TextQuantityHeader style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>Detalhes do Pedido</TextQuantityHeader>
                        </Col>
                      </Row>
                    </CardInputItem>
                    <ContainerCard>
                      <CardTable.Header style={CardHeader}>
                        <ContainerBody>
                          <Row>
                            <Col xs={4} className="p-0">
                              <Product>
                                <LeftItemQuantityDesktop>Item</LeftItemQuantityDesktop>
                                <LeftItemQuantityMobile>Inicial</LeftItemQuantityMobile>
                              </Product>
                            </Col>
                            <Col xs={4} className="p-0">
                              <CenterItemQuantityDesktop>Quantidade</CenterItemQuantityDesktop>
                              <CenterItemQuantityMobile>Qtd</CenterItemQuantityMobile>
                            </Col>
                            <Col xs={4} className="p-0">
                              <RightItemQuantity>{formatCurrency(getTotalCoast())}</RightItemQuantity>
                            </Col>
                          </Row>
                        </ContainerBody>
                      </CardTable.Header>

                      {orderDetails.products.map((products, index) => (
                        <Row key={index} style={{ padding: '0.5rem 2rem' }}>
                          <Col xs={4} className="p-0">
                            <Product>
                              <IconProduct
                                productName="p13"
                                styles={{
                                  p2: { margin: "0 .5rem .2rem 0", width: isMobile ? "15%" : "7%" },
                                  p5: { margin: "0 .5rem .2rem 0", width: isMobile ? "15%" : "7%" },
                                  p20: { margin: "0 .5rem .2rem 0", width: isMobile ? "10%" : "5%" },
                                  p45: { margin: "0 .5rem .2rem 0", width: isMobile ? "10%" : "5%" },
                                  p90: { margin: "0 .5rem .2rem 0", width: isMobile ? "10%" : "5%" },
                                  p13: { margin: "0 .5rem .2rem 0", width: isMobile ? "15%" : "7%" }
                                }}
                              />
                              <LeftItemQuantity>{products.name}</LeftItemQuantity>
                            </Product>
                          </Col>
                          <Col xs={4} className="p-0">
                            <CenterHeaderQuantity>{products.quantity}</CenterHeaderQuantity>
                          </Col>
                          <Col xs={4} className="p-0">
                            <RightItemQuantity>{formatCurrency(products.unitPrice * products.quantity)}</RightItemQuantity>
                          </Col>
                        </Row>
                      ))}
                    </ContainerCard>
                    {getTotalSubsidizedApplied() > 0 && (
                      <ContainerCard style={{ marginTop: '1rem' }}>
                        <CardTable.Header style={CardHeader}>
                          <ContainerBody>
                            <Row>
                              <Col xs={4} className="p-0">
                                <Product>
                                  <LeftItemSubdisizedDesk>Vasilhames Subsidiados</LeftItemSubdisizedDesk>
                                  <LeftItemSubdisizedMobile>Subsidiados</LeftItemSubdisizedMobile>
                                </Product>
                              </Col>
                              <Col xs={4} className="p-0">
                                <CenterItemQuantityDesktop>Quantidade</CenterItemQuantityDesktop>
                                <CenterItemQuantityMobile>Qtd</CenterItemQuantityMobile>
                              </Col>
                              <Col xs={4} className="p-0">
                                <RightItemQuantity>{formatCurrency(getTotalCoast())}</RightItemQuantity>
                              </Col>
                            </Row>
                          </ContainerBody>
                        </CardTable.Header>
                        {orderDetails.products.map((products) => (
                          products.sponsoredQuantity > 0 && (
                            <Row style={{ padding: '0.5rem 2rem' }}>
                              <Col xs={4} className="p-0">
                                <Product>
                                  <IconProduct
                                    productName="p13"
                                    styles={{
                                      p2: { margin: "0 .5rem .2rem 0", width: isMobile ? "15%" : "7%" },
                                      p5: { margin: "0 .5rem .2rem 0", width: isMobile ? "15%" : "7%" },
                                      p20: { margin: "0 .5rem .2rem 0", width: isMobile ? "10%" : "5%" },
                                      p45: { margin: "0 .5rem .2rem 0", width: isMobile ? "10%" : "5%" },
                                      p90: { margin: "0 .5rem .2rem 0", width: isMobile ? "10%" : "5%" },
                                      p13: { margin: "0 .5rem .2rem 0", width: isMobile ? "15%" : "7%" }
                                    }}
                                  />
                                    <LeftItemQuantity>{products.name}</LeftItemQuantity>
                                </Product>
                              </Col>
                              <Col xs={4} className="p-0">
                                <CenterHeaderQuantity>{products.sponsoredQuantity}</CenterHeaderQuantity>
                              </Col>
                              <Col xs={4} className="p-0">
                                <RightItemQuantity>---</RightItemQuantity>
                              </Col>
                            </Row>
                          )
                        ))}
                      </ContainerCard>
                    )}
                    {getTotalReplacementApplied() > 0 && (
                      <ContainerCard style={{ marginTop: '1rem' }}>
                        <CardTable.Header style={CardHeader}>
                          <ContainerBody>
                            <Row>
                              <Col xs={4} className="p-0">
                                <Product>
                                  <LeftItemReplacementDesk>Reposições Aplicadas</LeftItemReplacementDesk>
                                  <LeftItemReplacementMobile>Reposições</LeftItemReplacementMobile>
                                </Product>
                              </Col>
                              <Col xs={4} className="p-0">
                                <CenterItemQuantityDesktop>Quantidade</CenterItemQuantityDesktop>
                                <CenterItemQuantityMobile>Qtd</CenterItemQuantityMobile>
                              </Col>
                              <Col xs={4} className="p-0">
                                <RightItemQuantity>- {formatCurrency(getTotalReplacementApplied())}</RightItemQuantity>
                              </Col>
                            </Row>
                          </ContainerBody>
                        </CardTable.Header>
                        {orderDetails.products.map((products) => (
                          <Row style={{ padding: '0.5rem 2rem' }}>
                            <Col xs={4} className="p-0">
                              <Product>
                                <IconProduct
                                  productName="p13"
                                  styles={{
                                    p2: { margin: "0 .5rem .2rem 0", width: isMobile ? "15%" : "7%" },
                                    p5: { margin: "0 .5rem .2rem 0", width: isMobile ? "15%" : "7%" },
                                    p20: { margin: "0 .5rem .2rem 0", width: isMobile ? "10%" : "5%" },
                                    p45: { margin: "0 .5rem .2rem 0", width: isMobile ? "10%" : "5%" },
                                    p90: { margin: "0 .5rem .2rem 0", width: isMobile ? "10%" : "5%" },
                                    p13: { margin: "0 .5rem .2rem 0", width: isMobile ? "15%" : "7%" }
                                  }}
                                />
                                  <LeftItemQuantity>{products.name}</LeftItemQuantity>
                              </Product>
                            </Col>
                            <Col xs={4} className="p-0">
                              <CenterHeaderQuantity>{products.voucherQuantity + products.shiftQuantity}</CenterHeaderQuantity>
                            </Col>
                            <Col xs={4} className="p-0">
                              <RightItemQuantity>---</RightItemQuantity>
                            </Col>
                          </Row>
                        ))}
                      </ContainerCard>
                    )}
                    {getTotalDiscount() !== 0 && (
                      <ContainerCard style={{ marginTop: '1rem' }}>
                        <CardTable.Header style={CardHeader}>
                          <ContainerBody>
                            <Row>
                              <Col xs={6} className="p-0">
                                <Product>
                                  <LeftItemQuantity>Descontos</LeftItemQuantity>
                                </Product>
                              </Col>
                              <Col xs={6} className="p-0">
                              {getTotalDiscount() > 0 ? (
                                 <RightItemQuantity>- {formatCurrency(getTotalDiscount())}</RightItemQuantity>
                              ) : (
                                  <RightItemQuantity>{formatCurrency(getTotalDiscount())}</RightItemQuantity>
                              )}
                              </Col>
                            </Row>
                          </ContainerBody>
                        </CardTable.Header>
                        {orderDetails.creditNotesDiscount.map((discounts) => (
                          <Row style={{ padding: '0.5rem 2rem' }}>
                            <Col xs={4} className="p-0">
                              <LeftItemQuantity>{formatCreditNoteDescription(discounts.type)}</LeftItemQuantity>
                            </Col>
                            <Col xs={4} className="p-0">
                              <CenterHeaderQuantity>&nbsp;</CenterHeaderQuantity>
                            </Col>
                            <Col xs={4} className="p-0">
                              <RightItemQuantity>-{formatCurrency(discounts.value)}</RightItemQuantity>
                            </Col>
                          </Row>
                        ))}
                        {orderDetails.shippingTaxDiscount !== 0 &&
                          <Row style={{ padding: '0.5rem 2rem' }}>
                            <Col xs={4} className="p-0">
                              <LeftItemQuantity>Taxa de entrega</LeftItemQuantity>
                            </Col>
                            <Col xs={4} className="p-0">
                              <CenterHeaderQuantity>&nbsp;</CenterHeaderQuantity>
                            </Col>
                            <Col xs={4} className="p-0">
                              <RightItemQuantity>{formatCurrency(orderDetails.shippingTaxDiscount)}</RightItemQuantity>
                            </Col>
                          </Row>
                        }
                        {orderDetails.reweighingDiscountValue !== 0 &&
                          <Row style={{ padding: '0.5rem 2rem' }}>
                            <Col xs={4} className="p-0">
                              <LeftItemQuantity>Repesagem</LeftItemQuantity>
                            </Col>
                            <Col xs={4} className="p-0">
                              <CenterHeaderQuantity>&nbsp;</CenterHeaderQuantity>
                            </Col>
                            <Col xs={4} className="p-0">
                              <RightItemQuantity>{formatCurrency(orderDetails.reweighingDiscountValue)}</RightItemQuantity>
                            </Col>
                          </Row>
                        }
                        </ContainerCard>
                       )}
                      <ContainerCard style={{ marginTop: '1rem' }}>
                        <CardTable.Header style={CardHeaderTotal}>
                          <ContainerBody>
                            <Row>
                              <Col xs={6} className="p-0">
                                <Product>
                                  <LeftItemQuantityTotalDesktop>Valor Final do Pedido</LeftItemQuantityTotalDesktop>
                                  <LeftItemQuantityTotalMobile>Valor Final</LeftItemQuantityTotalMobile>
                                </Product>
                              </Col>
                              <Col xs={6} className="p-0">
                                <RightItemQuantityTotal>{formatCurrency(getTotal())}</RightItemQuantityTotal>
                              </Col>
                            </Row>
                          </ContainerBody>
                        </CardTable.Header>
                      </ContainerCard>
                    <ButtonDivision onClick={() => handleNext()}>
                      <InfoButton style={{ margin: "-1rem 0 1rem 0" }} disabled={loadingConfirm}>
                        {loadingConfirm ? (
                          <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                        ) : (
                          <div>Prosseguir</div>
                        )}
                      </InfoButton>
                    </ButtonDivision>
                  </MainContainer>
                  <OpenChatBot />
                </div>
                <Modal
                  show={modalOpen}
                  onHide={() => {
                    handleModal()
                  }}
                  centered={true}
                >
                  <Modal.Body>
                    <ModalContent>
                      <>
                        <CardInput>
                          <Row>
                            <Col>
                              <TextQuantity style={{ color: '#000FFF', margin: '0.5rem 0rem 0.5rem 0rem'}}>Para seguir para o pagamento, favor informar os dados abaixo</TextQuantity>
                            </Col>
                          </Row>
                          <CardInputItem>
                            <Row className="p-0">
                              <Col sm={4} className="p-0 d-flex align-items-center justify-content-center">
                                <TextQuantity>Email (obrigatório)</TextQuantity>
                              </Col>
                              <Col sm={8} className="p-0">
                                <Dropdown>
                                    <Dropdown.Toggle
                                      as={CustomSelectEmail}
                                      id="dropdown-custom-contact"
                                      onBlur={() => {}}
                                    >
                                      <span style={{ fontSize: '0.8rem' }}>
                                        {emails && emails?.length > 0 && (
                                          emails[emailIndex]?.email?.length > 37
                                            ? emails[emailIndex]?.email.substring(0, 34) + '...'
                                            : emails[emailIndex]?.email
                                        )}
                                      </span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu style={{ width: '100%' }}>
                                    {emails.map((element, index) => {
                                        return (
                                        <Dropdown.Item
                                            key={element.id}
                                            eventKey={`${element.id}`}
                                            onClick={() => {
                                              setEmailIndex(index);
                                              setEmail(element.email);
                                            }}
                                            style={AlignDropdownBranch}
                                        >
                                            <Align>
                                            <Radio
                                                color="primary"
                                                checked={
                                                  emails &&
                                                  logisticReducer?.selectedEmailIndex !== undefined &&
                                                  emails[logisticReducer.selectedEmailIndex]?.email ===
                                                    (element && element.email)
                                                }
                                              />
                                              <span className="product" style={{ fontSize: '0.7rem',  margin: '0.6rem 1.5rem' }}>
                                                  {element.email.length > 37
                                                    ? element.email.substring(0, 34) + '...'
                                                    : element.email
                                                  }
                                              </span>{' '}
                                            </Align>
                                        </Dropdown.Item>
                                        );
                                    })}
                                    </Dropdown.Menu>
                                </Dropdown>
                              </Col>
                            </Row>
                          </CardInputItem>
                          <CardInputItem>
                            <Row className="p-0">
                              <Col sm={4} className="p-0 d-flex align-items-center justify-content-center">
                                <TextQuantity>Telefone (opcional)</TextQuantity>
                              </Col>
                              <Col sm={8} className="p-0">
                                <ColAppliedHeaderQuantity>
                                  <InputApply
                                    value={phone}
                                    onChange={(e) => setPhone(formatContactNumber(e.target.value))}
                                    maxLength={15}
                                  />
                                </ColAppliedHeaderQuantity>
                              </Col>
                            </Row>
                          </CardInputItem>
                        </CardInput>
                        <Row>
                          <Col>
                            <TextQuantity style={{ marginBottom: '1rem', marginTop: '0.5rem'}} >Caso queira incluir um novo e-mail, cadastre um novo usuário no MAP, com acesso ao Status do Pedido.</TextQuantity>
                          </Col>
                        </Row>
                        <InfoButton disabled={loadingConfirmModal} onClick={() => orderCompletion()}>
                          {loadingConfirmModal ? (
                            <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                          ) : (
                            <div>Prosseguir</div>
                          )}
                        </InfoButton>
                      </>
                    </ModalContent>
                  </Modal.Body>
                </Modal>
                <OpenChatBot backgroundColor={'#00f3ff'} />
              </CardOrder>
            </>
          )}
        </>
      ) : (
        <Redirect to="/portal" />
      )}
    </Container>
  );
}
